(function () {
  'use strict';
  function init(root) {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    var record;
    try { record = JSON.parse(sessionStorage.getItem('tbCustomSurveyReceipt') || 'null'); } catch (_error) {}
    var valid = record && /^TBC-[a-f0-9-]{20,64}$/i.test(record.receipt || '') && /^#?\s*[a-z0-9-]{3,32}$/i.test(record.order || '') && Date.now() - Number(record.at) < 7 * 24 * 60 * 60 * 1000;
    root.querySelector('[data-tbct-confirmed]').hidden = !valid;
    root.querySelector('[data-tbct-unconfirmed]').hidden = !!valid;
    if (!valid) return;
    var order = '#' + String(record.order).trim().replace(/^#\s*/, '');
    root.querySelector('[data-tbct-order]').textContent = order;
    root.querySelector('[data-tbct-receipt]').textContent = record.receipt;
    var subject = 'Survey $10 Refund Order ' + order;
    var body = 'Hello Thera Hair support,\n\nI completed the TB Custom Survey and would like to request the $10 refund for order ' + order + '.\n\nSurvey confirmation: ' + record.receipt + '\n\nI have attached a screenshot of the survey confirmation page.\n\nThank you.';
    root.querySelector('[data-tbct-email]').href = 'mailto:support@therahair.com?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
  }
  function initAll() { document.querySelectorAll('.tbct').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
}());
